import React, { FC } from "react"
import {
  GatsbyImage,
  IGatsbyImageData,
} from "gatsby-plugin-image"

import { getImgixImageData, getImgixUrl } from "@utils"

import "./ImageAboveFold.scss"

type ImageAboveFoldProps = {
  alt: string
  aspectRatio: number
  className?: string
  imageData?: IGatsbyImageData
  role?: string | null
  src?: string
  width?: number
}

const ImageAboveFold: FC<ImageAboveFoldProps> = ({
  alt,
  aspectRatio,
  className,
  imageData,
  src = "",
  width = 100,
  ...props
}) => {
  const isGif = src?.includes(".gif")
  const isSvg = src?.includes(".svg")
  const imageAttrs =
    !(isGif || isSvg) && imageData
      ? {
        alt,
        className: `ImageAboveFold ${className ? className : ""}`,
        image: imageData,
      }
      : {
        alt,
        className: `ImageAboveFold ${className ? className : ""}`,
        src: isGif ? getImgixUrl(src) : isSvg ? src : undefined,
        image: isGif ? undefined : isSvg ? undefined : getImgixImageData(src, width, aspectRatio),
      }

  return (
    <>
      {(isGif || isSvg) ? (
        <img {...imageAttrs} loading="eager" />
      ) : (
        <GatsbyImage
          {...imageAttrs}
          {...props}
          loading="eager"
          placeholder="none"
        />
      )}
    </>
  )
}

export default ImageAboveFold
